// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"604e9480","395":"36245f24","572":"36245f24","666":"0ac036f2","738":"36245f24"}[chunkId] + ".chunk.css";
};